import type { ShopSectionFilter } from "@alm/domain";
import { graphSearch } from "@/routes/_authenticated/nancy/-components/graph/graph-search";
import { DEFAULT_SECTION, isSectionId } from "@/routes/_authenticated/nancy/-lib/section-ids";

interface NancySettingsSearch {
  section?: string;
  /** In What Nancy knows: the node lit up. */
  focus?: string;
  /** In What Nancy knows: food or a kind of supplies, alone. */
  show?: ShopSectionFilter;
}

/** A stale or hand-edited section falls back to the first rather than erroring. */
export function settingsSearch(search: Record<string, unknown>): NancySettingsSearch {
  return {
    ...(isSectionId(search.section) && search.section !== DEFAULT_SECTION
      ? { section: search.section }
      : {}),
    ...graphSearch(search),
  };
}
